import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import SEO from "../components/SEO";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("e") || "";
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get("/unsubscribe", { params: { e: email } }).then(() => setDone(true)).catch(() => setDone(true));
  }, [email]);

  return (
    <div className="px-4 max-w-md mx-auto py-24 text-center">
      <SEO title="Unsubscribed — Tendly" />
      <CheckCircle2 className="w-12 h-12 text-primary mx-auto" />
      <h1 className="mt-4 font-heading font-bold text-2xl" data-testid="unsubscribe-done">You're unsubscribed</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        {done && email ? `${email} has been added to our do-not-contact list. You won't receive further outreach emails from Tendly.` : "Processing your request…"}
      </p>
      <a href="/" className="mt-6 inline-block text-sm text-primary font-semibold hover:underline">Back to Tendly</a>
    </div>
  );
}
